import UserInfo from "./UserInfo";

export const TOKEN_KEY = "Token";
export const isAuthenticated = () => UserInfo.estaAutenticado();
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const login = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("User_Info");
};

let sessaoEncerrada = false;
export const encerrarSessaoExpirada = () => {
  if (sessaoEncerrada) return;
  sessaoEncerrada = true;
  logout();
  window.location.replace("/?sessao=expirada");
};
